export default {
  labels: {
    custom: 'Tilpasset - Fås på forespørgsel',
    was: 'Var {{amount}} – årsrabat anvendt',
  },
  tags: {
    preferred: 'Særligt populær',
    net_one_time: 'netto engangsbeløb',
    annual_discount: '-{{percentage}}% årligt',
  },
  buttons: {
    select_plan: 'Vælg denne plan',
  },
};
